import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const PlaceBottomIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M19.3604 11.999V13.3604C19.3602 16.6738 16.6739 19.3602 13.3604 19.3604H10.6396C7.32627 19.3601 4.63982 16.6738 4.63965 13.3604V11.999H19.3604Z" fill="currentColor" />;
    t1 = <path d="M4 9C4 6.23858 6.23858 4 9 4H15C17.7614 4 20 6.23858 20 9V15C20 17.7614 17.7614 20 15 20H9C6.23858 20 4 17.7614 4 15V9ZM5.5 15C5.5 16.933 7.067 18.5 9 18.5H15C16.933 18.5 18.5 16.933 18.5 15V9C18.5 7.067 16.933 5.5 15 5.5H9C7.067 5.5 5.5 7.067 5.5 9V15Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props || $[3] !== ref) {
    t2 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = ref;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
});
export default PlaceBottomIcon;